<template>
	<div class="pin-editor">
		<div class="pin-editor-inner">
			<div>
				<div>
					<strong>Resource</strong>
				</div>
				<select class="small-margin-right" v-model="resource_object">
					<option value="order">Order</option>
					<option value="product">Product</option>
					<option value="user">User</option>
				</select>
				<input type="number" v-model="resource_id" />
			</div>
			<div class="small-margin-top">
				<div>
					<strong>Event description</strong>
				</div>
				<input type="text" v-model="event" />
				<div class="note small-margin-top">
					For instance "paymentintent:duplicate-charge"
				</div>
			</div>
			<div class="small-margin-top">
				<div>
					<strong>Message</strong>
				</div>
				<textarea cols="50" rows="3" v-model="message"></textarea>
			</div>
			<div class="small-margin-top border-top padding-top">
				<button :disabled="saving" v-on:click="save()">Save</button>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
export default {
  props: [

  ],
  data: () => ({
    event: '',
    message: '',
    resource_object: 'order',
    resource_id: '',
    saving: false
  }),
  methods: {
    save () {
      Vue.api.post('/pin', {
        resource_object: this.resource_object,
        resource_id: this.resource_id,
        event: this.event,
        message: this.message
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.$emit('saved')
      })
    }
  }
}
</script>

<style lang="less" scoped>
	.pin-editor {
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		background: rgba(0, 0, 0, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
		.pin-editor-inner {
			background: #fff;
			padding: 30px;
			width: 400px;
			// height: 300px;
		}
	}
</style>
